export const LineManager = 'lineManager';
export const ExecutiveManager = 'executiveManager';
export const AlternativeOfficer = 'alternativeOfficer';


// WEBPACK FOOTER //
// ./app/constants/responsibleOfficerType.js